"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _components = require("../components");
var _components2 = require("../../../components");
var _containers = require("../containers");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const mapStateToProps = state => {
  return {
    auth: state.auth
  };
};
const SignInView = props => {
  const {
    auth
  } = props;
  let header = "Log In";
  let image = null;
  if (auth.login && auth.login.header) header = auth.login.header;
  if (auth.login && auth.login.image) image = `/${auth.login.image}`;
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "flex",
      flexFlow: "column",
      height: "100%"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container-fluid pb-5 justify-content-center position-relative"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row justify-content-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-12 col-md-10 col-lg-8 col-xl-5"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex justify-content-center mb-5"
  }, image && /*#__PURE__*/_react.default.createElement("img", {
    src: image
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "card rounded shadow p-5"
  }, /*#__PURE__*/_react.default.createElement("h4", null, header), /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-4"
  }, /*#__PURE__*/_react.default.createElement(_containers.SignIn, props, /*#__PURE__*/_react.default.createElement(_components.SignInForm, null))))))), /*#__PURE__*/_react.default.createElement(_components2.ImprintLink, null));
};
SignInView.propTypes = process.env.NODE_ENV !== "production" ? {
  auth: _propTypes.default.object
} : {};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(SignInView);
module.exports = exports.default;